import { ORCHESTRATION_SERVICE_API } from '../constants/AppConstants';

/**
 * Split a sitemap report into measurement reports for selected building IDs.
 * POST /v1/sitemap/split-with-building-ids/{encryptedReportId}
 *
 * @param {object} params
 * @param {string} params.encryptedReportId
 * @param {number[]} params.buildingIds
 * @param {string} [params.imagelink]
 * @returns {Promise<{ok: boolean, json?: object, status?: number, error?: string}>}
 */
const submitSitemapApprovalService = async ({
  encryptedReportId,
  buildingIds,
  imagelink = '',
}) => {
  try {
    const response = await fetch(
      `${ORCHESTRATION_SERVICE_API}/v1/sitemap/split-with-building-ids/${encodeURIComponent(encryptedReportId)}`,
      {
        method: 'POST',
        credentials: 'omit',
        skipAuthHeader: true,
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          buildingIds,
          imagelink: imagelink || '',
        }),
      },
    );

    const json = await response.json().catch(() => null);

    if (response.status !== 200 && response.status !== 201) {
      return {
        ok: false,
        status: response.status,
        json,
        error: json?.errorDescription || 'Failed to split report with building IDs',
      };
    }

    return { ok: true, status: response.status, json };
  } catch (error) {
    return { ok: false, error: error.message };
  }
};

export default submitSitemapApprovalService;
